module.exports = __webpack_public_path__ + "img/icon_back.aeb88f85.svg";